import recordApi from "@/api/record";
import category from "@/api/category";

const record = {
  namespaced: true,
  state: {
    list: [],
    categoryList: [],
  },
  getters: {},
  mutations: {
    setList(state, data) {
      state.list = data;
    },
  },
  actions: {
    lists({ commit }, data) {
      return recordApi.accountBookList(data).then((res) => {
        commit("setList", res.value);
      });
    },
    edit({ commit }, data) {
      return recordApi.accountBookEdit(data).then((res) => {
        return res;
      });
    },
    import({ commit }, data) {
      return recordApi.accountBookImport(data).then((res) => {
        return res;
      });
    },
    preview({ commit }, data) {
      return recordApi.accountBookPreview(data).then((res) => {
        return res;
      });
    },
    queryList({ commit }, data) {
      return recordApi.accountBookQuery(data).then((res) => {
        return res;
      });
    },
    export({ commit }, data) {
      return recordApi.accountBookExport(data).then((res) => {
        return res;
      });
    },
    customerExport({ commit }, data) {
      return recordApi.customerStockExport(data).then((res) => {
        return res;
      });
    },
  },
};

export default record;
